import { useQuery } from '@tanstack/react-query';

import { CenterLocation } from 'types/location';

export type GetLocationsResponse = CenterLocation[];

export async function fetchLocations() {
	const response = await fetch(`${process.env.APP_PATH}/api/get-locations/`);
	const data = await response.json();

	if (!response.ok) {
		throw new Error(data.message);
	}

	return data as GetLocationsResponse;
}

export function useGetLocations() {
	const { error, isFetching, data } = useQuery({
		queryKey: ['getLocations'],
		queryFn: () => fetchLocations(),
	});
	return { error, isFetching, data };
}
